<template>
	<div id="download">
		<div class="bac">
			<img :src="require('../../static/image/ss/downbac1.png')" class="downhead"/>
			<div class="content">
				<!-- <div class="headBtn">
					<div :class="selectIndex == 0 ? 'btnSelect' : 'btnNormal'"  @click="changeIndex(0)">{{$t('download.text1')}}</div>
					<div :class="selectIndex == 1 ? 'btnSelect' : 'btnNormal'" @click="changeIndex(1)">{{$t('download.text2')}}</div>
				</div> -->
				
				<div class="appbac" v-show="selectIndex == 0">
					<img loading="lazy" v-lazy="$common.getTitleLogo('logo1')" class="appleft"/>
					<div class="appmid">
						<div class="title1">{{$t('download.text1')}}</div>
						<div class="sub">{{$t('download.text3')}}</div>
						<div class="title2bac">
							<div class="title2">{{$t('download.text4')}}</div>
							<img loading="lazy" v-lazy="require('../../static/image/ss/downicon.png')" class="dwonIcon"/>
						</div>
						<div class="bottomCode">
                            <div class="code" id="qrcode1"></div>
							<div class="downBtnBac" @click="downApp(0)">
								<div class="downbtn">
									<img loading="lazy" v-lazy="require('../../static/image/ss/android.png')"/>
									<img loading="lazy" v-lazy="require('../../static/image/ss/dowcorner.png')" class="corner"/>
                                    
								</div>
								<div class="downbtn" style="margin-top: 10px;" @click="downApp(1)">
									<img loading="lazy" v-lazy="require('../../static/image/ss/apple.png')"/>
									<img loading="lazy" v-lazy="require('../../static/image/ss/dowcorner.png')" class="corner"/>
								</div>
							</div>
						</div>
					</div>
					<img :src="$common.getTitleLogo('app1')" class="appright"/>
				</div>
				
				<!-- <div class="appbac" v-show="selectIndex == 1">
					<img loading="lazy" v-lazy="require('../../static/image/ss/logo.png')" class="appleft"/>
					<div class="appmid">
						<div class="title1">{{$t('download.text4')}}</div>
						<div class="sub">{{$t('download.text5')}}</div>
						<div class="sub">({{$t('download.text6')}})</div>
						<div class="downpcbtn" @click="downPcApp(0)">{{$t('download.text7')}}</div>
						<div class="downpcbtn" style="margin-top: 10px;" @click="downPcApp(1)">{{$t('download.text8')}}</div>
					</div>
					<img loading="lazy" v-lazy="require('../../static/image/ss/pc1.png')" class="appright"/>
				</div> -->
			</div>
		</div>
		
		
	</div>
</template>

<script>
    import QRCode from '@keeex/qrcodejs-kx';
	export default {
        components: { QRCode},
		data (){
			return{
                selectIndex:0,
                sessData: '',
                apkUrl: '',
                projectName: window.projectName,
                openUrl: '',
			}
		},
		watch: {	
		  '$route' (to, from) { //监听路由是否变化
		    if(this.$route.query.index){
				this.selectIndex = this.$route.query.index
		    }else {
				this.selectIndex = 0
			}
		  }
        },
        mounted() {
            this.clientCode();
        },
		methods:{
            // clientCode: async function() {
            //     let self = this;
            //     let params = '/' + window.clientCode;
            //     const res = await self.$http.get(self.$api.clientCode, params, false);
            //     if (res.code == 0) {
            //         self.$common.setClientCodeRes(res.data);
            //         self.codeList();
            //     }
            // },
			clientCode () {
				setTimeout(() => {
					const datas = this.$common.getConfigUrl();
					if (datas) {
						this.codeList()
					} else {
						this.clientCode()
					}
				}, 1000)
			},
            codeList() {
                // let that = this;
                // that.sessData = JSON.parse(sessionStorage.getItem('inviteCode'));
                // let u = window.location.hostname;
                // let a = u.split('.');
                // if (a.length > 2){
                //     a = a.slice(a.length - 2);
                // }
                // let s = 'http://m.' + a.join('.');
                // that.sessData = JSON.parse(sessionStorage.getItem('inviteCode'));
                // let arrNew = '';
                // if (that.sessData) {
                //     arrNew = s + '?code=' + that.sessData;
                //     that.apkUrl = `${this.$config.dowUrl}${window.clientCode}${window.theme}/${that.sessData}`;
                // } else {
                //     arrNew = s;
                //     that.apkUrl = `${this.$config.dowUrl}${window.clientCode}${window.theme}`;
                // }
                // that.openUrl = arrNew;
                // this.qrcode('qrcode1',that.apkUrl);
                // this.qrcode('qrcode2',that.openUrl);
				let url = location.origin + '/downloadUrl?',
				iosUrl = this.$common.getIosDownloadUrl(),
				androidUrl = this.$common.getAndroidDownloadUrl(),
				pcUrl = this.$common.getPcDownloadUrl();
				url += 'code=' + window.childCode;
				if (iosUrl) {
					url += '&ios=' + encodeURIComponent(iosUrl)
				}
				if (androidUrl) {
					url += '&android=' + encodeURIComponent(androidUrl)
				}
				// if (pcUrl) {
				// 	url += '&pc=' + encodeURIComponent(pcUrl)
				// }
				this.apkUrl = url;
				this.qrcode('qrcode1', this.apkUrl);
            },
            qrcode(qrcodeId, qrcode) {
                new QRCode(qrcodeId, {
                    'width': 220, // 设置宽度，单位像素
                    'height': 220, // 设置高度，单位像素
                    'text': qrcode // 设置二维码内容或跳转地址
                });
            },
			changeIndex(index){
				this.selectIndex = index
			},  
			downApp(index){
				window.open(this.apkUrl)
			},
			downPcApp(index){
				if (index == 0){
                    // window.open(this.$config.PTUrl,'_blank')
					this.$message(this.$t('download.text9'))
				}else {
                    // window.open(this.$config.PTUrl,'_blank')
					this.$message(this.$t('download.text9'))
				}
			}
			
		}
	}
</script>

<style scoped>
	.bac{
		background-color: #f5f5f5;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.downhead {
		margin: 0 auto;
		width: 100%;
		display: flex;
		z-index: 10;
	}
	.content{
		margin: 0 auto;
		background-color: #f5f5f5;
		padding-top: 30px;
		padding-bottom: 50px;
	}
	.headBtn {
		margin: 0 auto;
		width: 376px;
		height: 44px;
		border-radius: 22px;
		display: flex;
		overflow: hidden;
		flex-direction: row;
		background-color: #FFFFFF;
	}
	.btnNormal {
		width: 188px;
		height: 100%;
		background-color: #FFFFFF;
		color: #000000;
		font-size: 14px;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.btnSelect {
		width: 188px;
		height: 100%;
		background-color: #F54;
		color: #FFF;
		font-size: 14px;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.appbac {
		margin: 0 auto;
		width: 1200px;
		/* margin-top: 30px; */
		display: flex;
		flex-direction: row;
	}
	.appleft {
		width: 42px;
		height: 42px;
	}
	.appmid{
		margin-left: 10px;
		width: 1050px;
	}
	
	.title1 {
		font-size: 24px;
		font-weight: 400;
		line-height: 42px;
	}
	.sub {
		margin-top: 10px;
		font-size: 13px;
		color: #999999;
		margin-left: 0px;
		width: 80%;
	}
	.title2bac{
		margin-top: 40px;
		display: flex;
		flex-direction: row;
	}
	.title2 {
		font-size: 16px;
		font-weight: 400;
	}
	.dwonIcon{
		width: 36px;
		height: 16px;
		margin-left: 10px;
	}
	
	.bottomCode {
		display: flex;
		margin-top: 20px;
		flex-direction: row;
	}
	.code {
		/* width: 110px;
		height: 110px; */
	}
	.downBtnBac{
		display: flex;
		flex-direction: column;
		margin-left: 20px;
	}
	.downbtn{
		width: 150px;
		height: 50px;
		border-radius: 5px;
		display: flex;
		flex-direction: row-reverse;
		/* background-color: ; */
		cursor: pointer;
	}
	.downbtn:hover{
		opacity: .85;
	}
	.downpcbtn{
		margin-top: 20px;
		width: 150px;
		height: 50px;
		color: #FFf;
		justify-content: center;
		align-items: center;
		font-size: 15px;
		border-radius: 10px;
		display: flex;
		background-color: #a29ebb;
	}
	
	.corner{
		position: absolute;
		margin-right: 0px;
		color: #FFFFFF;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 14px;
	}
	.appright{
		margin-left: 20px;
		width: 550px;
		height: 310px;
	}
	
</style>
